import * as yup from 'yup';
import 'yup-phone';
import { OptionSet } from '../tools/utils';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export const useOrganizationSchema = () => {
  const { t, i18n } = useTranslation();

  return useMemo(() => {
    const getRequiredMessage = (key: string) =>
      t(`organization.validation.required.${key}`);

    return yup.object().shape({
      Name: yup.string().trim().required(getRequiredMessage('name')),
      City: yup.string().trim().required(getRequiredMessage('city')),
      Address1: yup.string().trim().required(getRequiredMessage('street1')),
      ZipCode: yup.string().trim().required(getRequiredMessage('zipCode')),
      StateId: yup
        .string()
        .required(getRequiredMessage('state'))
        .notOneOf(['', 'default'], getRequiredMessage('state')),
      CountryId: yup
        .string()
        .required(getRequiredMessage('country'))
        .notOneOf(['', 'default'], getRequiredMessage('country')),
      Type: yup.string().trim().required(getRequiredMessage('type')),
      OtherType: yup.string().when('Type', {
        is: (value: string) => value === OptionSet.Other.toString(),
        then: yup.string().required(getRequiredMessage('otherType')),
        otherwise: yup.string().notRequired(),
      }),
      LegalName: yup.string().trim().required(getRequiredMessage('legalName')),
      WebsiteUrl: yup
        .string()
        .trim()
        .matches(
          /^(https?:\/\/)?([\w\-]+\.)+[\w\-]{2,}(\/[\w\-./?%&=]*)?$/,
          t('organization.validation.url')
        )
        .required(getRequiredMessage('website')),
    });
  }, [i18n.language]); // ✅ This ensures schema is rebuilt when language changes
};
